export default () => ({
  images: [],
  statusImages: undefined,
});
